import { MateriaResponse } from "../..";

export interface MateriaGruppoResponse {
    gruppoId: string;
    materie: Array<MateriaResponse>;
    nomeGruppo: string;
    selected?: boolean;
}